<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <OrfEval orfName="gender"
             :orfType="registeringPersonType">
        <template v-slot:default="{required}">
            <OrfEval :doNotHide="true"
                     orfName="name"
                     :orfType="registeringPersonType">
                <template v-slot:default="{hidden}">
                    <CardSelect type="radio"
                                v-model="person.gender"
                                :required="required"
                                :name="$t('eventRegistration.person.gender')"
                                :fixedWidthSm="true">
                        <CardSelectItem v-for="gender in allowedGenders"
                                        :disabled="gender.value && genderDisabled[gender.value]"
                                        :value="gender.value"
                                        :key="gender.value"
                                        :icon="gender.value && genderIcons[gender.value]">
                            {{ gender.label }}
                        </CardSelectItem>
                    </CardSelect>
                    <div class="mt--2 mb-3">
                        <base-input v-if="currentGender === 'w' && getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations !== null"
                                    :model-value="-getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations"
                                    noMargin
                                    mode="aggressive" :rules="{tooManyFemales: true}" :validateImmediate="true">
                            <input class="d-none">
                        </base-input>
                        <base-input v-if="currentGender === 'm' && getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations !== null"
                                    :model-value="-getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations"
                                    noMargin
                                    mode="aggressive" :rules="{tooManyMales: true}" :validateImmediate="true">
                            <input class="d-none">
                        </base-input>
                        <div class="invalid-feedback text-dark d-block" v-if="allMaleTaken">
                            {{ $t('eventRegistration.person.allTakenMale') }}
                        </div>
                        <div class="invalid-feedback text-dark d-block" v-if="allFemaleTaken">
                            {{ $t('eventRegistration.person.allTakenFemale') }}
                        </div>
                    </div>
                </template>
            </OrfEval>
        </template>
    </OrfEval>
</template>

<script>
import OrfEval from "@/components/pages/registration/OrfEval";
import formSelectChoiceMixin from "@/mixins/registration/formSelectChoiceMixin";
import registrationPersonMixin from "@/mixins/registration/registrationPersonMixin";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import diverseSalutationKey from "@/util/consts/diverseSalutationKey";

export default {
    name: "ParticipantGender",
    mixins: [registrationPersonMixin, formSelectChoiceMixin, registrationOnlineRegistrationFieldsMixin],
    components: {OrfEval},
    props: {
        registeringPersonType: {
            required: true,
            type: String,
            description: "participant or invoiceRecipient"
        }
    },
    data() {
        return {
            diverseSalutationKey: diverseSalutationKey.DIVERSE_SALUTATION_KEY,
            noneSalutationKey: diverseSalutationKey.NONE_SALUTATION_KEY
        }
    },
    computed: {
        currentGender() {
            return this.person.gender
        },
        allowedGenders() {
            if (!this.genders) return []
            return this.genders.filter(gender => this.diverseSalutation || gender.value !== 'd')
        },
        genderDisabled() {
            return {
                'w': this.allFemaleTaken,
                'm': this.allMaleTaken,
                'd': false
            }
        },
        genderIcons() {
            return {
                'w': 'venus',
                'm': 'mars',
                'd': 'neuter'
            }
        },
        allFemaleTaken() {
            if (this.currentGender && this.currentGender.gender === 'w') {
                return false
            } else if (this.getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations !== null &&
                this.getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations <= 0) {
                return true
            } else {
                return false
            }
        },
        allMaleTaken() {
            if (this.currentGender && this.currentGender.gender === 'm') {
                return false
            } else if (this.getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations !== null &&
                this.getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations <= 0) {
                return true
            } else {
                return false
            }
        }
    },
    watch: {
        'person.salutation': {
            handler(value) {
                if (value && !this.person?.gender) {
                    let newSalutation = this.salutations?.find(salutation => salutation.title === value)
                    if (newSalutation?.gender && !this.genderDisabled[newSalutation?.gender])
                        this.person.gender = newSalutation?.gender ?? null
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
